import * as React from "react";

function SvgPlusCircleSolid(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        d="M12 2C6.476 2 2 6.476 2 12s4.476 10 10 10 10-4.476 10-10S17.524 2 12 2zm5.806 11.129a.485.485 0 01-.483.484h-3.71v3.71a.485.485 0 01-.484.483h-2.258a.485.485 0 01-.484-.483v-3.71h-3.71a.485.485 0 01-.483-.484v-2.258c0-.266.217-.484.483-.484h3.71v-3.71c0-.266.218-.483.484-.483h2.258c.266 0 .484.217.484.483v3.71h3.71c.266 0 .483.218.483.484v2.258z"
        fill="currentColor"
      />
    </svg>
  );
}

const ForwardRef = React.forwardRef(SvgPlusCircleSolid);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
